<template>
  <div class="widget-accordion-custom">
    <div v-if="showAccordion" class="widget-accordion-content">
      <details v-for="(item, index) in items" :key="index" class="widget-accordion-item" :open="index===0" :style="item.itemStyle || null">
        <summary class="widget-accordion-summary" :style="item.headerStyle || null">
          <div class="widget-accordion-header">
            <div v-html="item.title"></div>
            <b-badge v-if="item.badge" variant="dark">{{ item.badge }}</b-badge>
          </div>
        </summary>
        <div class="widget-accordion-body" v-if="item.body" v-html="item.body" :style="item.bodyStyle || null"></div>
      </details>
    </div>
    <b-alert v-else variant="warning" show class="m-3">
      {{ this.data.items }}
    </b-alert>
  </div>
</template>

<script>
  export default {
    props: {
      data: {
        type: Object,
        required: true
      },
    },
    data(){
      return {
        items: [],
        showAccordion: false,
      }
    },
    mounted() {
      this.configureData()
    },
    watch: {
      data: function(){
        this.configureData()
      }
    },
    methods: {
      configureData() {
        if(typeof this.data.items == 'string') {
          this.showAccordion = false
          this.items = []
        } else {
          this.showAccordion = true
          this.items = this.data.items
        }
      },
    }
  }
</script>

<style>
  .widget-accordion-custom {
    height: 100%;
    min-height: 0;
    overflow: visible;
  }
  .widget-accordion-content {
    padding: 8px;
  }
  .widget-accordion-item {
    border: 1px solid #d6d6d6;
    border-radius: 4px;
    margin-bottom: 8px;
    background: #fff;
  }
  .widget-accordion-summary {
    list-style: none;
    cursor: pointer;
    padding: 8px 10px;
    font-size: 13px;
  }
  .widget-accordion-summary::-webkit-details-marker {
    display: none;
  }
  .widget-accordion-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }
  .widget-accordion-body {
    border-top: 1px solid #e8e8e8;
    padding: 8px 10px;
    font-size: 12px;
    color: #343a40;
    background: #fafafa;
  }
</style>
